/* eslint-disable import/prefer-default-export */

// 测试用
export const SET_PRODUCT_NO = 'SET_PRODUCT_NO';
export const SET_HOME_INFO = 'SET_HOME_INFO';
export const SET_HAS_THEME = 'SET_HAS_THEME';
export const SET_WEAL_INFO = 'SET_WEAL_INFO';
export const SET_SWIPER_INDEX = 'SET_SWIPER_INDEX';



// WEBPACK FOOTER //
// ./src/store/mutationType.js